import { render, staticRenderFns } from "./PlotDeleteDialog.vue?vue&type=template&id=7d4829a2&scoped=true"
import script from "./PlotDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./PlotDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./PlotDeleteDialog.vue?vue&type=style&index=0&id=7d4829a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4829a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d4829a2')) {
      api.createRecord('7d4829a2', component.options)
    } else {
      api.reload('7d4829a2', component.options)
    }
    module.hot.accept("./PlotDeleteDialog.vue?vue&type=template&id=7d4829a2&scoped=true", function () {
      api.rerender('7d4829a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/PlotDeleteDialog.vue"
export default component.exports